import React, { useState } from 'react';
import Modal from '../UI/Modal';
import { FileText, Check } from 'lucide-react';

// Templates básicos pré-definidos (MVP)
const TEMPLATES_BASICOS = {
    evolucao: [
        {
            id: 'evolucao-simples',
            nome: 'Evolução Simples',
            tipo: 'evolucao',
            categoria: null,
            conteudo_template: `Data: ${new Date().toLocaleDateString('pt-BR')}

Evolução:

Paciente em bom estado geral.
Sinais vitais estáveis.
Sem intercorrências.

Conduta:
- Manter tratamento atual
- Reavaliar em 24h`
        },
        {
            id: 'evolucao-soap',
            nome: 'Evolução SOAP',
            tipo: 'evolucao',
            categoria: 'soap',
            conteudo_template: `Data: ${new Date().toLocaleDateString('pt-BR')}

S - SUBJETIVO:
Paciente relata:

O - OBJETIVO:
Exame físico:
- Estado geral:
- Sinais vitais:
- Exame físico:

A - AVALIAÇÃO:
Diagnóstico/Impressão diagnóstica:

P - PLANO:
Conduta:
1. 
2. 
3. `
        }
    ],
    intercorrencia: [
        {
            id: 'intercorrencia-simples',
            nome: 'Intercorrência',
            tipo: 'intercorrencia',
            categoria: null,
            conteudo_template: `Data: ${new Date().toLocaleDateString('pt-BR')}
Hora: ${new Date().toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })}

INTERCORRÊNCIA:

Descrição do evento:

Ações tomadas:

Resultado:

Observações:`
        }
    ],
    observacao: [
        {
            id: 'observacao-simples',
            nome: 'Observação',
            tipo: 'observacao',
            categoria: null,
            conteudo_template: `Data: ${new Date().toLocaleDateString('pt-BR')}

OBSERVAÇÃO:

`
        }
    ]
};

const TemplateSelector = ({ pacienteId, tipo = 'evolucao', onSelect, onClose }) => {
    const [selectedTemplate, setSelectedTemplate] = useState(null);

    const templates = TEMPLATES_BASICOS[tipo] || [];

    const handleSelect = () => {
        if (selectedTemplate) {
            onSelect(selectedTemplate);
        }
    };

    return (
        <Modal
            isOpen={true}
            onClose={onClose}
            title="Selecionar Template"
            size="lg"
        >
            <div className="space-y-4">
                {templates.length > 0 ? (
                    <>
                        <div className="space-y-2">
                            {templates.map((template) => (
                                <div
                                    key={template.id}
                                    onClick={() => setSelectedTemplate(template)}
                                    className={`p-4 border-2 rounded-lg cursor-pointer transition-all ${
                                        selectedTemplate?.id === template.id
                                            ? 'border-emerald-500 bg-emerald-50'
                                            : 'border-gray-200 hover:border-emerald-300 hover:bg-gray-50'
                                    }`}
                                >
                                    <div className="flex items-start justify-between">
                                        <div className="flex items-start gap-3">
                                            <FileText className={`w-5 h-5 mt-0.5 ${
                                                selectedTemplate?.id === template.id
                                                    ? 'text-emerald-600'
                                                    : 'text-gray-400'
                                            }`} />
                                            <div>
                                                <h3 className="font-medium text-gray-900">{template.nome}</h3>
                                                {template.categoria && (
                                                    <p className="text-xs text-gray-500 mt-1">
                                                        Categoria: {template.categoria.toUpperCase()}
                                                    </p>
                                                )}
                                            </div>
                                        </div>
                                        {selectedTemplate?.id === template.id && (
                                            <Check className="w-5 h-5 text-emerald-600" />
                                        )}
                                    </div>
                                    {selectedTemplate?.id === template.id && (
                                        <div className="mt-3 p-3 bg-white rounded border border-gray-200">
                                            <p className="text-xs text-gray-600 font-mono whitespace-pre-wrap">
                                                {template.conteudo_template.substring(0, 200)}
                                                {template.conteudo_template.length > 200 ? '...' : ''}
                                            </p>
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>

                        <div className="flex justify-end gap-3 pt-4 border-t border-gray-200">
                            <button
                                onClick={onClose}
                                className="px-4 py-2 text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200"
                            >
                                Cancelar
                            </button>
                            <button
                                onClick={handleSelect}
                                disabled={!selectedTemplate}
                                className="px-4 py-2 bg-emerald-600 text-white rounded-lg hover:bg-emerald-700 disabled:bg-gray-400 disabled:cursor-not-allowed"
                            >
                                Usar Template
                            </button>
                        </div>
                    </>
                ) : (
                    <div className="text-center py-8">
                        <FileText className="w-12 h-12 text-gray-400 mx-auto mb-3" />
                        <p className="text-gray-500">
                            Nenhum template disponível para este tipo de nota.
                        </p>
                        <button
                            onClick={onClose}
                            className="mt-4 px-4 py-2 text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200"
                        >
                            Fechar
                        </button>
                    </div>
                )}
            </div>
        </Modal>
    );
};

export default TemplateSelector;

